"use client";
import { useTranslations } from "next-intl";
import Button from "../../theme/components/Button";

const LoadMoreButton = ({ visible, onLoadMore }) => {
  const t = useTranslations();
  return visible ? (
    <Button appearance="primary" onClick={onLoadMore}>
      {t("load_more")}
    </Button>
  ) : null;
};

export default LoadMoreButton;
